<template>
<div class="panal mt-20">
<div class="panal-header">Terms and Conditions </div>

  <div class="container">
    <div class="row">
      <div class="col-md-12" >
      
        <div class="text-center mt-5" v-html="TermsList.TermsConditions"></div>
        <!-- <button type="button" class="btn btn-outline-primary" >Read Pdf for Terms and Conditions </button> -->
      

      </div>
      <div class="col-md-12 text-center mb-5 mt-3" align="center">
          <div class="form-group m-auto">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="gridCheck" :checked="TermsAccept.isAgreed" v-model="TermsAccept.isAgreed" :disabled="hasValue">
            <label class="form-check-label" for="gridCheck">
              I Accept Terms and Conditions
            </label>
          </div>
        </div>
          <button type="button" class="btn btn-outline-primary mt-3" @click="handleAcceptTerms" :disabled="hasValue" > Accept terms and conditions </button>

        </div>
    </div>
  </div>
</div>




</template>

<script>
  import ApplicantService from '../../services/Applicant/Applicant.service'
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
import { TermsAccept } from '../../models/Applicant';
  export default {

    data() {
      return {
        TermsList: [],
        //IsAccepted : false,
        TermsCheck:[],
        hasValue:false,
        TermsAccept : new TermsAccept ('','',false,false)
      }
    },
    mounted() {
      ApplicantService.GetTermsandConditions().then(Response => {
        this.TermsList = Response.data[0]
        this.TermsAccept.termSerial = this.TermsList.Serial

      }, error => {

        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
this.getApplicantTerms()
      
    },
    methods: {
        handleAcceptTerms(){
            if (!this.TermsAccept.isAgreed){
            this.TermsAccept.FlagTerm = false
            }else{
               this.TermsAccept.FlagTerm = true
               localStorage.setItem('terms',true)
            }
            this.TermsAccept.ApplicantSerial = this.currenUser.UserIDSerial

              ApplicantDataServices.PostApplicantTerms(this.TermsAccept).then(Response => {
             this.message = Response.data[0]
              this.getApplicantTerms()
            }, error => {

        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
     
        },
         getApplicantTerms(){
        ApplicantDataServices.PostCheckApplicantTermsAccept(this.currenUser.UserIDSerial).then(Response => {
        this.TermsCheck = Response.data
        if(this.TermsCheck.isAgreed == true){
          this.TermsAccept.isAgreed = true
          this.TermsAccept.FlagTerm = true
          this.hasValue = true
         localStorage.setItem('terms',true)

        }

      }, error => {
                   localStorage.setItem('terms',false)

        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });
      }
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      }
    },
  }
</script>

<style scoped>
  table tr th {
    background-color: #4caf5000 !important;
    color: #333;
  }

  .panal{
  background:#fff;
  border-radius:10px;
color:#333;
padding:0px 0px 50px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>